import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLockBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_9425_457624)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M100.25 45C100.25 43.4812 99.0188 42.25 97.5 42.25H22.5C20.9812 42.25 19.75 43.4812 19.75 45V97.5C19.75 99.0188 20.9812 100.25 22.5 100.25H97.5C99.0188 100.25 100.25 99.0188 100.25 97.5V45ZM102.25 97.5C102.25 100.123 100.123 102.25 97.5 102.25H22.5C19.8766 102.25 17.75 100.123 17.75 97.5V45C17.75 42.3766 19.8766 40.25 22.5 40.25H97.5C100.123 40.25 102.25 42.3766 102.25 45V97.5Z",
				fill: "#14151F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.25 41.25V26.25C40.25 21.012 42.3303 15.988 46.0342 12.2842C49.738 8.58034 54.762 6.5 60 6.5C69.5312 6.5 77.8928 13.2614 79.7295 22.3008C79.8394 22.8419 79.4903 23.3694 78.9492 23.4795C78.4081 23.5894 77.8806 23.2403 77.7705 22.6992C76.129 14.62 68.6094 8.5 60 8.5C55.2924 8.5 50.778 10.3704 47.4492 13.6992C44.1204 17.028 42.25 21.5424 42.25 26.25V41.25C42.25 41.8023 41.8023 42.25 41.25 42.25C40.6977 42.25 40.25 41.8023 40.25 41.25Z",
				fill: "#14151F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M67.5 71.6216C67.5 67.4794 64.1421 64.1216 60 64.1216C55.8579 64.1216 52.5 67.4794 52.5 71.6216C52.5 75.7637 55.8579 79.1216 60 79.1216C64.1421 79.1216 67.5 75.7637 67.5 71.6216ZM69.5 71.6216C69.5 76.8683 65.2467 81.1216 60 81.1216C54.7533 81.1216 50.5 76.8683 50.5 71.6216C50.5 66.3749 54.7533 62.1216 60 62.1216C65.2467 62.1216 69.5 66.3749 69.5 71.6216Z",
				fill: "url(#paint0_linear_9425_457624)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_9425_457624",
		x1: 50.5,
		y1: 81.1216,
		x2: 72.8829,
		y2: 75.4336,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#E45D96"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9425_457624",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 120,
			height: 120,
			fill: "white"
		})
	})] })]
});
export default SvgLockBig;
